import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const DownArrowIcon = (props) => {
  return (
    <SvgIcon
      width="17" height="10" viewBox="0 0 17 10"
      {...props}>
      <path d="M258,489l-6.5,7.065L245,489" transform="translate(-242.881 -486.88)" fill="none" stroke="var(--primary)"
            strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/>
    </SvgIcon>
  );
};

DownArrowIcon.propTypes = {}

DownArrowIcon.defaultProps = {}

export default DownArrowIcon;